import { render } from "./CurrencyBadge.vue?vue&type=template&id=412ed084&ts=true"
import script from "./CurrencyBadge.vue?vue&type=script&lang=ts"
export * from "./CurrencyBadge.vue?vue&type=script&lang=ts"

import "./CurrencyBadge.vue?vue&type=style&index=0&id=412ed084&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/currency/CurrencyBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "412ed084"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('412ed084', __exports__)) {
    api.reload('412ed084', __exports__)
  }
  
  module.hot.accept("./CurrencyBadge.vue?vue&type=template&id=412ed084&ts=true", () => {
    api.rerender('412ed084', render)
  })

}


export default __exports__